import { CreatorShopMembershipProductListPage } from './CreatorShopMembershipProductListPage';

export const creatorShopMembershipProductListRouter = {
  '/membership/products': CreatorShopMembershipProductListPage,
};
